import { render, staticRenderFns } from "./ShowSearchPropertyComponent.vue?vue&type=template&id=225419a2"
import script from "./ShowSearchPropertyComponent.vue?vue&type=script&lang=js"
export * from "./ShowSearchPropertyComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports